module.exports = "pegasus_template/assets/blocks/column-7-theme6.png";